<ul ngbNav #nav="ngbNav" class="nav-tabs">
    <li ngbNavItem>
        <a ngbNavLink>Orders Volume</a>
        <ng-template ngbNavContent>
            <app-overview-report [dropdownListBO]="dropdownListBO" [dropdownListOrderCluster]="dropdownListOrderCluster"
                [dropdownListCustomer]="dropdownListCustomer" [dropdownListCountry]="dropdownListCountry"
                [dropdownListMonth]="dropdownListMonth" [dropdownListYear]="dropdownListYear"
                [dropdownListOrderType]="dropdownListOrderType" [orderTypeOfOrderCLuster]="orderTypeOfOrderCLuster"
                [customerOfCountry]="customerOfCountry" [selectedItemsBO]="selectedItemsBO"
                [selectedItemsOrderCluster]="selectedItemsOrderCluster" [selectedItemsCustomer]="selectedItemsCustomer"
                [selectedItemsCountry]="selectedItemsCountry" [selectedItemsMonth]="selectedItemsMonth"
                [selectedItemsYear]="selectedItemsYear" [selectedItemsOrderType]="selectedItemsOrderType"
                [pieChartLabels]="pieChartLabels" [orders]="orders" [pieChartData]="pieChartData"
                [idLeadGlobalOfCustomerName]="idLeadGlobalOfCustomerName"
                [selectedItemsIdGlobal]="selectedItemsIdGlobal" [dropdownListOrderStatus]="dropdownListOrderStatus"
                [dropdownListLead]="dropdownListLead" [selectedItemsOrderStatus]="selectedItemsOrderStatus"
                [selectedItemsLead]="selectedItemsLead" (loadReportEvent)="loadReportOverview($event)">
            </app-overview-report>
        </ng-template>
    </li>
    <li ngbNavItem style="margin-left: 1%;">
        <a ngbNavLink>Orders Detail </a>
        <ng-template ngbNavContent>
            <app-order-detail [dropdownListBO]="dropdownListBO" [dropdownListOrderCluster]="dropdownListOrderCluster"
                [dropdownListCustomer]="dropdownListCustomer" [dropdownListCountry]="dropdownListCountry"
                [dropdownListMonth]="dropdownListMonth" [dropdownListYear]="dropdownListYear"
                [dropdownListOrderType]="dropdownListOrderType" [orderTypeOfOrderCLuster]="orderTypeOfOrderCLuster"
                [customerOfCountry]="customerOfCountry" [selectedItemsBO]="selectedItemsBO"
                [selectedItemsOrderCluster]="selectedItemsOrderCluster" [selectedItemsCustomer]="selectedItemsCustomer"
                [selectedItemsCountry]="selectedItemsCountry" [selectedItemsMonth]="selectedItemsMonth"
                [selectedItemsYear]="selectedItemsYear" [selectedItemsOrderType]="selectedItemsOrderType"
                [listOrder]="listOrder" [listOrderSelected]="listOrderSelected"
                [idLeadGlobalOfCustomerName]="idLeadGlobalOfCustomerName"
                [selectedItemsIdGlobal]="selectedItemsIdGlobal" [dropdownListOrderStatus]="dropdownListOrderStatus"
                [dropdownListLead]="dropdownListLead" [selectedItemsOrderStatus]="selectedItemsOrderStatus"
                [selectedItemsLead]="selectedItemsLead" (loadReportEvent)="loadReportOrderDetail($event)"
                (loadReportSelectedEvent)="loadReportOrderDetailSelected($event)">
            </app-order-detail>
        </ng-template>
    </li>
    <li ngbNavItem ngbNavItem style="margin-left: 1%;">
        <a ngbNavLink>SLA Metrics </a>
        <ng-template ngbNavContent>
            <app-sla-kpis [dropdownListBO]="dropdownListBO" [dropdownListOrderCluster]="dropdownListOrderCluster"
                [dropdownListCustomer]="dropdownListCustomer" [dropdownListCountry]="dropdownListCountry"
                [dropdownListMonth]="dropdownListMonth" [dropdownListYear]="dropdownListYear"
                [dropdownListOrderType]="dropdownListOrderType" [orderTypeOfOrderCLuster]="orderTypeOfOrderCLuster"
                [customerOfCountry]="customerOfCountry" [selectedItemsBO]="selectedItemsBO"
                [selectedItemsOrderCluster]="selectedItemsOrderCluster" [selectedItemsCustomer]="selectedItemsCustomer"
                [selectedItemsCountry]="selectedItemsCountry" [selectedItemsMonth]="selectedItemsMonth"
                [selectedItemsYear]="selectedItemsYear" [selectedItemsOrderType]="selectedItemsOrderType"
                [chart_Data]="chart_Data" [listAverage]="listAverage" [selectedItemsIdGlobal]="selectedItemsIdGlobal"
                [idLeadGlobalOfCustomerName]="idLeadGlobalOfCustomerName"
                [dropdownListOrderStatus]="dropdownListOrderStatus" [dropdownListLead]="dropdownListLead"
                [selectedItemsOrderStatus]="selectedItemsOrderStatus" [selectedItemsLead]="selectedItemsLead"
                [pieChartLabels]="labelSlaKpi" [pieChartData]="singleDataSetSlaKpi"
                (loadReportEvent)="loadReportSlaKpi($event)">
            </app-sla-kpis>
        </ng-template>
    </li>
    <li ngbNavItem ngbNavItem style="margin-left: 1%;">
        <a ngbNavLink>Orders Completed Trend </a>
        <ng-template ngbNavContent>
            <app-completed-detail [dropdownListBO]="dropdownListBO"
                [dropdownListOrderCluster]="dropdownListOrderCluster" [dropdownListCustomer]="dropdownListCustomer"
                [dropdownListCountry]="dropdownListCountry" [dropdownListMonth]="dropdownListMonth"
                [dropdownListYear]="dropdownListYear" [dropdownListOrderType]="dropdownListOrderType"
                [orderTypeOfOrderCLuster]="orderTypeOfOrderCLuster" [customerOfCountry]="customerOfCountry"
                [selectedItemsBO]="selectedItemsBO" [selectedItemsOrderCluster]="selectedItemsOrderCluster"
                [selectedItemsCustomer]="selectedItemsCustomer" [selectedItemsCountry]="selectedItemsCountry"
                [selectedItemsMonth]="selectedItemsMonth" [selectedItemsYear]="selectedItemsYear"
                [selectedItemsOrderType]="selectedItemsOrderType" [chart_Labels]="chart_Labels"
                [chart_Data]="chart_DataCompleted" [idLeadGlobalOfCustomerName]="idLeadGlobalOfCustomerName"
                [selectedItemsIdGlobal]="selectedItemsIdGlobal" [dropdownListOrderStatus]="dropdownListOrderStatus"
                [dropdownListLead]="dropdownListLead" [selectedItemsOrderStatus]="selectedItemsOrderStatus"
                [selectedItemsLead]="selectedItemsLead" (loadReportEvent)="loadReportCompletedDetail($event)">
            </app-completed-detail>
        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="nav" *ngIf="viewTab()"></div>